"use strict";
/**
 * Created on 04 22 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var WindowItemProductSuppliers_1 = require("../model/WindowItemProductSuppliers");

var WindowItemProductSuppliersConverter_1 = require("./WindowItemProductSuppliersConverter");
/**
 * Implementation of {@link WindowItemProductSuppliersConverter}.
 *
 * @author JMe
 */


var WindowItemProductSuppliersConverterImpl =
/*#__PURE__*/
function (_WindowItemProductSup) {
  _inherits(WindowItemProductSuppliersConverterImpl, _WindowItemProductSup);

  function WindowItemProductSuppliersConverterImpl() {
    _classCallCheck(this, WindowItemProductSuppliersConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemProductSuppliersConverterImpl).apply(this, arguments));
  }

  _createClass(WindowItemProductSuppliersConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new WindowItemProductSuppliers_1.WindowItemProductSuppliers(WindowItemProductSuppliers_1.WindowItemProductSuppliers.schema.itemId.valueOf(conversions.toClassReferenceId(source.itemId)), WindowItemProductSuppliers_1.WindowItemProductSuppliers.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), WindowItemProductSuppliers_1.WindowItemProductSuppliers.schema.preferredSupplierId.valueOf(utils_1.Utils.isValueMissing(source.preferredSupplierId) ? null : conversions.toClassReferenceId(source.preferredSupplierId)), WindowItemProductSuppliers_1.WindowItemProductSuppliers.schema.supplierIds.valueOf(conversions.asClassReferenceIdsSet(source, 'supplierIds')));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        itemId: conversions.toDocumentReferenceId(source.itemId),
        productId: conversions.toDocumentReferenceId(source.productId),
        preferredSupplierId: utils_1.Utils.isValueMissing(source.preferredSupplierId) ? null : conversions.toDocumentReferenceId(source.preferredSupplierId),
        supplierIds: conversions.asObjectArray(source, 'supplierIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        })
      });
      return result;
    }
  }]);

  return WindowItemProductSuppliersConverterImpl;
}(WindowItemProductSuppliersConverter_1.WindowItemProductSuppliersConverter);

exports.WindowItemProductSuppliersConverterImpl = WindowItemProductSuppliersConverterImpl;